var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#414142",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.75c0 .899-.72 1.625-1.67 1.625H5.868l5.658 5.352a1.563 1.563 0 0 1 0 2.298 1.775 1.775 0 0 1-1.219.475c-.44 0-.879-.159-1.214-.476L.503 12.899a1.563 1.563 0 0 1 0-2.298l8.589-8.125a1.787 1.787 0 0 1 2.429 0 1.563 1.563 0 0 1 0 2.298l-5.654 5.351H22.33c.95 0 1.669.726 1.669 1.625Z"
  })));
};
export default SvgArrowLeft;